import { Link } from "@remix-run/react";

import Logo from "~/components/logo";

// AIDEV-NOTE: Help center footer. Rendered once by the help.tsx layout route
// inside the shared content column, for both auth states.
export function HelpFooter() {
    return (
        <footer className="border-t px-4 py-4 sm:px-6">
            {/* AIDEV-NOTE: Wraps on narrow screens. justify-between with three
                non-wrapping children forced the row wider than a phone viewport,
                which pushed the whole help page into horizontal overflow — content
                was clipped on BOTH edges, not just the footer. */}
            <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs text-muted-foreground sm:justify-between">
                <Logo size="sm" variant="image" />
                <span>2025 Evolve Labs Inc. All rights Reserved</span>
                <div className="flex gap-4">
                    <Link to="/privacy" className="hover:underline">
                        Privacy Policy
                    </Link>
                    <Link to="/terms" className="hover:underline">
                        Terms Of Use
                    </Link>
                </div>
            </div>
        </footer>
    );
}
